<template>
  <side-base>
    <div class="swrap">
      <div class="smain">
        <div class="slist">
          <div
            class="sitem van-hairline--bottom"
            v-for="item in listAll"
            :key="item.id"
            @click="clickHandler(item)"
          >
            <div class="l sicon">
              <side-icon-select :checked="ids.includes(item.id)" />
            </div>
            <div class="r">
              {{ item.itemName }}
            </div>
          </div>
        </div>
        <van-empty
          v-if="listAll.length === 0 && !loading"
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          description="没有年级数据~"
          image-size="128"
          style="margin-top: 20vh"
        ></van-empty>
      </div>
      <side-foot @cancel="close" @confirm="confirm(getRet())" >
        <select-Base
          :show="!config.radio"
          :ids="ids"
          :list="list"
          :isAll="checkAll"
          @clickAllBtn="setCheckAll"
          :key_txt="'itemName'"
        />
      </side-foot>
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-select.js';

export default {
  name: 'x3-side-grade',
  mixins: [sideMixin],
  data() {
    return {
      pageTitle: '公立年级',
      loading: true,    
      config: {
        must: false,
      },
    }
  },
  methods:{
    async render() {
      this.$api.gradelList().then((res) => {
        if (res.code == 200) {
          console.log(res)
          this.listAll = res.data.map(v=> {
            return {
              id: Number(v.dictCode),
              itemName: v.dictName
            }
          })
          this.loading = false;
        }
      });
    },
    setCheckAll() {
      this.checkAll = !this.checkAll;
    },
  },
  created () {    
    this.render();
  },

}
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .shead {
    .toolbar {
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g8);
    }
  }
  .smain {
    flex: 1;
    overflow: auto;
    .slist {
      padding: 0 calc(var(--gap) * 16);
      background: var(--white);
      .sitem {
        display: flex;
        align-items: center;
        padding: calc(var(--gap) * 12) 0;
        .l.sicon {
          height: calc(var(--w) * 20);
          margin-right: calc(var(--gap) * 16);
        }
        .r {
          flex: 1;
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          display: flex;
          align-items: center;
          background: var(--white);
        }
      }
    }
  }
}


</style>